import Notation from './core/notation';
// export default Notation;
// http://stackoverflow.com/a/33683495/112731
module.exports = Notation;



// WEBPACK FOOTER //
// ./src/index.js